import { type Placement, TextCaption, Tooltip } from '@carboncopyco/ui';
import { isDesktop } from '@carboncopyco/utils';
import type React from 'react';

interface PlaybookPreviewTooltipProps {
  previewRef: React.RefObject<HTMLElement>;
  desktopDomain: string;
  location: Location;
  placement?: Placement;
  playId?: string;
  extraNavigationPath?: string;
}

export const PlaybookPreviewTooltip: React.FC<PlaybookPreviewTooltipProps> = ({
  previewRef,
  desktopDomain,
  location,
  extraNavigationPath,
  playId,
  placement = 'bottom',
}) => {
  return (
    <>
      {!isDesktop() && (
        <Tooltip
          anchorRef={previewRef}
          placement={placement}
          noArrow
        >
          <div className="p-3 w-56 ">
            <TextCaption label="Previewing Playbooks on web is not supported at the moment. Please use the " />
            <a
              href={`${desktopDomain}://navigate${
                location.pathname
              }/${extraNavigationPath}?mode=preview${playId ? `&playId=${playId}` : ''}`}
              rel="noreferrer"
              className="text-ds-200 font-ds-inter text-ds-primary-300"
            >
              desktop app
            </a>
            <TextCaption label="." />
          </div>
        </Tooltip>
      )}
    </>
  );
};
